/* eslint-disable import/order */
/* eslint-disable simple-import-sort/sort */
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from 'src/App';

import 'formiojs';
import 'formiojs/dist/formio.full.css';

import 'src/styles/formio-modal.css';
import 'src/styles/index.scss';

import 'jquery';

const rootEl = document.querySelector('#root');
if (!rootEl) {
    throw new Error('Mount node #root not found');
}

createRoot(rootEl).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
